<div class="flex flex-col w-full mb-4">
  <label
    *ngIf="label"
    [attr.for]="id"
    class="block mb-2 text-gray-900 body-small-regular"
    >{{ label }}</label
  >
  <div
    *ngIf="loading"
    class="h-[48px] w-full flex justify-center items-center border border-gray-300 rounded"
  >
    <app-loading-indicator [size]="25"></app-loading-indicator>
  </div>

  <ng-container *ngIf="!loading">
    <select
      [(ngModel)]="value"
      [attr.id]="id"
      [attr.name]="id"
      (change)="onSelect($event)"
      class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-brand-orange sm:leading-6 outline-none h-14"
    >
      <option
        *ngFor="let option of options"
        [value]="option.value"
        [selected]="option.value === value"
      >
        {{ option.label }}
      </option>
    </select>

    <!-- this uses angular material - but style overrides are needed -->
    <!-- <mat-form-field>
            <mat-select [(ngModel)]="value">
                <mat-option
                    *ngFor="let option of options"
                    [value]="option.value"
                >
                    {{option.label}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->
  </ng-container>
</div>
